import React from 'react';
import { twMerge } from 'tailwind-merge';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  noPadding?: boolean;
  interactive?: boolean;
}
export function Card({
  children,
  className,
  noPadding = false,
  interactive = false,
  ...props
}: CardProps) {
  return <div className={twMerge('bg-white rounded-2xl shadow-soft overflow-hidden', !noPadding && 'p-4 sm:p-6', interactive && 'cursor-pointer transition-transform active:scale-[0.98] hover:shadow-md', className)} {...props} data-id="element-54">
      {children}
    </div>;
}